import { AnySchema } from 'ajv';

import { FieldErrorMessage } from '../../../../models/FieldErrorMessage';
import { validateFormData } from '../../../../utils/validations/validateFormData';
import { ICreateSROrganizationSubscriptionExtensionModel } from '../../../../models/interfaces/Subscription/SecurityResponse/CreateSROrganizationSubscriptionExtensionModel';

const schema: AnySchema | any = {
  type: 'object',
  properties: {},
  dependencies: {},
  required: [],
};

export const validateExtendSRSubscriptionForm = (
  data: ICreateSROrganizationSubscriptionExtensionModel,
  additionalErrors?: FieldErrorMessage[],
) => validateFormData(data, additionalErrors, schema);
